import { MY_ACCOUNT_SIDEBAR_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TMyAccountSidebarSelector, TEqualityFunction } from '../types';

export const useMyAccountSidebarSelector = <TSelected>(
    selector: TMyAccountSidebarSelector<TSelected>,
    equalityFn?: TEqualityFunction<TSelected>
) => {
    return useCustomSelector<TSelected, typeof MY_ACCOUNT_SIDEBAR_REDUCER>(MY_ACCOUNT_SIDEBAR_REDUCER, selector, equalityFn);
};
